export default __webpack_public_path__ + "static/media/1314 spice rack top.ce57ec22.png";